import { render, staticRenderFns } from "./table.tax.vue?vue&type=template&id=3e435064&scoped=true"
import script from "./table.tax.vue?vue&type=script&lang=js"
export * from "./table.tax.vue?vue&type=script&lang=js"
import style0 from "./table.tax.vue?vue&type=style&index=0&id=3e435064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e435064",
  null
  
)

export default component.exports